<template>
    <div class="bg-tgThemeBgColor">
        <slot></slot>
    </div>
</template>
